import * as yup from 'yup';

export const companySymbolsValidation = yup
  .string()
  .nullable()
  .when('isControlPerson', {
    is: true,
    then: yup
      .string()
      .nullable()
      .required('Please enter a valid company name'),
  });
